import { Stack, useTheme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import companyData from '../../../assets/data/company.json';

const JobOverview = ({
    data
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                width='100%'
                spacing={{xs: 3, md: 4}}
                data-aos="zoom-in"
            >
                <OverviewParagraph 
                    title="Level"
                    description={data.level}
                />

                <OverviewParagraph 
                    title="Location"
                    description={data.location}
                />

                <OverviewParagraph 
                    title="Contract Length"
                    description={data.contractLength}
                />

                <OverviewParagraph 
                    title="Employment Basis"
                    description={data.employment}
                />

                <OverviewParagraph 
                    title="The Role"
                    description={data.roleBrief}
                />

                <OverviewBulletPoints 
                    title="The Role"
                    list={data.requiredSkills}
                />

                <OverviewBulletPoints 
                    title="Here are some Bonus Skills you might have"
                    list={data.additionalSkills}
                />

                <OverviewParagraph 
                    title={t('careers.jobOpenings.companyOverview.title')}
                    description={t('careers.jobOpenings.companyOverview.description')}
                />
            </Stack>

            {/* Email */}
            <Stack
                direction='column'
                justifyItems='start'
                alignItems='center'
                width='100%'
                spacing={{xs: 0.5, md: 1}}
                pt={{xs: 3, md: 5, lg: 10}}
                pb={{xs: 3, md: 0}}
            >
                <Typography
                    fontWeight={500}
                    fontSize={{xs: 14, md: 24}}
                    textAlign='center'
                    color={theme.palette.text.secondary}
                    lineHeight={1.5}
                >
                    {t('careers.jobOpenings.shareCV')}
                </Typography>

                <Link
                    to={`mailto:${companyData.contact.careers_email}`}
                    style={{
                        textDecoration: 'none'
                    }}
                >
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 14, md: 24}}
                        textAlign='center'
                        color={theme.palette.text.primary}
                        lineHeight={1.5}
                        sx={{
                            '&: hover': {
                                transform: 'scale(1.1)'
                            }
                        }}
                    >
                        {companyData.contact.careers_email}
                    </Typography>
                </Link>
            </Stack>
        </>
    );
}

export default JobOverview;

const OverviewParagraph = ({
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                spacing={{xs: 1.5, md: 1}}
            >  
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 12, lg: 14}}
                    textAlign="justify"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}

const OverviewBulletPoints = ({
    title,
    list
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                spacing={{xs: 1.5, md: 1}}
            >  
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                {
                    list.map((item, index) => {
                        return <Stack
                            key={index}
                            direction='row'
                            justifyContent='start'
                            alignItems='start'
                        >
                            <Typography
                                fontWeight={600}
                                fontSize={{xs: 12, md: 12, lg: 14}}
                                textAlign="justify"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                                px={1}
                            >
                                -
                            </Typography>

                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 12, lg: 14}}
                                textAlign="justify"
                                lineHeight={1.5}
                                color={theme.palette.text.primary}
                            >
                                {item}
                            </Typography>
                        </Stack>
                    })
                }
            </Stack>
        </>
    );
}